import { ConditionEvaluator } from '@leverege/condition';
export default class StringNotEqualsComparatorEvaluator extends ConditionEvaluator {
  satisfies(context) {
    const {
      attribute,
      target
    } = context;
    const targetValue = attribute?.get(target?.data);
    const value1 = this.model.value1;
    if (targetValue == null || targetValue.length === 0 || value1 == null || value1.length === 0) {
      return null;
    }
    if (value1 === targetValue) {
      return false;
    }
    if (!Array.isArray(value1)) {
      return true;
    }
    return !value1.includes(targetValue);
  }
}